import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from "../../security/auth.service";
import { ValidationService } from '../../shared/validation/validation.service';
import { APP_CONFIG, AppConfig } from '../../shared/app-config.module';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../shared/language/language.service';
import { IApplicationConfiguration } from '../../models/IApplicatinConfiguration';
import { ICompany } from '../../models/ICompany';
import { AlertService } from '../../shared/alert/alert.service';
import { finalize } from 'rxjs/operators';

@Component({
  templateUrl: './change.password.component.html',
  styleUrls: ['./change.password.style.css']
})

export class ChangePasswordComponent implements OnInit {
  model: any = {};
  loading = false;
  returnUrl: string;
  changePasswordForm: FormGroup;
  submitted = false;
  pUsername: string;
  language: string;
  pAccessToken: string;
  passwrodLength: number;
  configuration: IApplicationConfiguration;
  filteredCompanies: ICompany[];
  regexUrl = ".*"  //Needed (ngPattern surrounds with ^ and $)
    + "(?=^.{6,}$)"       //At least 6 Characters
    + "(?=[^\\d]*\\d)"    //At least one digit
    + "(?=[^\\W]*\\W)"    //At least one special character
    + "(?=[^A-Z]*[A-Z])"  //At least one uppercase character
    + "(?=[^a-z]*[a-z])"  //At least one lowercase character
    + ".*";    //Needed (ngPattern surrounds with ^ and $)

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private alertService: AlertService,
    private validationService: ValidationService,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    public languageService: LanguageService,
    @Inject(APP_CONFIG) config: AppConfig) {

    this.passwrodLength = config.passwordLength;
    this.language = this.languageService.getLanguage();

    var configuration = localStorage.getItem(config.storageApplicationConfiguration);
    if (configuration != null && configuration != "")
      this.configuration = JSON.parse(configuration);
    else
      this.configuration = <IApplicationConfiguration>{};
  }

  ngOnInit() {
    this.changePasswordForm = this.formBuilder.group({
      id: [''],
      username: [this.pUsername, Validators.required],
      oldPassword: ['', [Validators.required, Validators.minLength(this.passwrodLength)]],
      password: ['', [Validators.required, Validators.minLength(this.passwrodLength)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(this.passwrodLength)]],
      language: [this.language, [Validators.required]],
      companyName: [this.configuration.companyName, Validators.required],
      serverInstance: [this.configuration.serverInstance, [Validators.required, Validators.pattern(this.regexUrl)]],
    }, {
      validator: [
        ValidationService.match('password', 'confirmPassword')
      ]
    });

    this.authService.logout();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';

    var serverInstance = this.changePasswordForm.controls.serverInstance.value;
    if (serverInstance == undefined || serverInstance == null || serverInstance == "") {
      this.loading = true;
      this.authService.getSetup().subscribe(
        data => {
          this.changePasswordForm.controls['serverInstance'].setValue(data.base_Url_Web_Service);
          this.loading = false;
        },
        error => {
          let obj = JSON.parse(error._body);
          this.validationService.mapValidationServerMessage(obj, this.changePasswordForm);
          this.loading = false;
        });
    } 
  }

  onSubmit(model) {
    this.submitted = true;
    this.changePasswordForm.controls['id'].updateValueAndValidity();
    if (this.changePasswordForm.invalid) {
      return;
    }
    this.changePassword(model);
  }

  changePassword(model) {
    this.loading = true;
    this.authService.changePassword(model.value)
      .subscribe(
        () => {
          this.router.navigate(['login']);
        },
        error => {
          let obj = JSON.parse(error._body);
          this.validationService.mapValidationServerMessage(obj, this.changePasswordForm);
          this.loading = false;
        });
  }

  onChangeServerInstance() {
    this.changePasswordForm.controls.companyName.setValue('');
    this.filteredCompanies = [];
  }

  onFocusCompanyName() {
    this.lookupCompanyName();
  }

  lookupCompanyName() {
    this.alertService.clear();
    this.loading = true;
    var serverInstance = this.changePasswordForm.controls.serverInstance.value;
    return this.authService.loadCompanies(serverInstance)
      .pipe(
        finalize(() => {
          this.loading = false;
        }))
      .subscribe((results) => {
        this.filteredCompanies = results;
      }, (error) => {
        var err = error.json();
        this.alertService.error(err.message);
      });
  }
}
